import * as bootstrap from "bootstrap";
import Plyr from "plyr";

function syncWorkCarouselHeight(carouselElement) {
  if (!carouselElement.classList.contains("carousel--work")) {
    return;
  }

  const carouselWrapper = carouselElement.closest(".workDetail__carousel");
  const activeSlide = carouselElement.querySelector(".carousel-item.active");

  if (!carouselWrapper || !activeSlide) {
    return;
  }

  const activeMedia =
    activeSlide.querySelector(".plyr") ||
    activeSlide.querySelector("img, video, iframe");
  const activeHeight = Math.ceil(
    activeMedia?.getBoundingClientRect().height || activeSlide.getBoundingClientRect().height,
  );

  if (!activeHeight) {
    return;
  }

  const nextHeight = `${activeHeight}px`;

  if (carouselWrapper.style.height === nextHeight) {
    return;
  }

  carouselWrapper.style.height = nextHeight;
  window.dispatchEvent(
    new CustomEvent("work-carousel:heightchange", {
      detail: {
        carousel: carouselWrapper,
      },
    }),
  );
}

export function initializeCarousels() {
  Array.from(document.querySelectorAll(".carousel")).forEach((citem) => {
    const carousel = new bootstrap.Carousel(citem);

    syncWorkCarouselHeight(citem);

    citem.addEventListener("slid.bs.carousel", () => {
      syncWorkCarouselHeight(citem);
    });

    if (citem.id === "contactFeature") {
      window.setInterval(() => {
        carousel.next();
      }, 3000);
    }
    if (citem.id === "aboutFeature") {
      window.setInterval(() => {
        carousel.next();
      }, 3000);
    }
  });
}

export function initializeVideo() {
  document.querySelectorAll(".carousel--work img").forEach((image) => {
    image.addEventListener("load", () => {
      const carouselElement = image.closest(".carousel");

      if (carouselElement) {
        syncWorkCarouselHeight(carouselElement);
      }
    });
  });

  const players = Array.from(document.querySelectorAll(".js-player")).map(
    (element) => {
      const carouselElement = element.closest(".carousel");

      ["loadedmetadata", "loadeddata"].forEach((eventName) => {
        element.addEventListener(eventName, () => {
          if (carouselElement) {
            syncWorkCarouselHeight(carouselElement);
          }
        });
      });

      return {
        element,
        player: new Plyr(element),
      };
    },
  );

  // this adds event listeners to restart when hidden, so autoplay works
  ["slide.bs.carousel", "hidden.bs.modal"].forEach((eventName) => {
    document.body.addEventListener(eventName, (event) => {
      if (eventName === "slide.bs.carousel") {
        const activeSlide = event.target.querySelector(".carousel-item.active");
        const mediaContainer = activeSlide?.querySelector(".mediaContainer");

        if (mediaContainer) {
          players.forEach(({ element, player }) => {
            if (mediaContainer.contains(element)) {
              player.pause();
            }
          });
        }
      }

      players.forEach(function ({ element, player }) {
        if (event.target.contains(element)) {
          player.restart();
        }
      });
    });
  });
}
